import React, {useMemo, useState} from "react";

import {Container, MaxBtn} from "../core/components";
import {MyModal, MyReactTable} from "../core/input_fields";
import {maxiGet, maxiPost} from "../core/maxios";
import Status from "../core/status";
import {AddressPrinter, encodeGetParams} from "../core/helpers";
import BillingAddressEdit from "./billingAddressEdit";


export default function BillingAddressList({nameCell, club_ID}) {
    const [billingAddresses, setBillingAddresses] = useState([]);
    const [{error, loading, success}, setStatusVar] = useState({loading: true});
    const loadBillingAddress = () => {
        maxiGet("/billing_address?" + encodeGetParams({club_ID}), {setStatusVar}).then(data => {
            setBillingAddresses(data.billing_addresses)
        })
    }
    useMemo(loadBillingAddress, []);
    return <Container name={"Rechnungsadressen"}>
        <div style={{float: "right", marginTop: "-60px"}}>
            <MyModal trigger={<MaxBtn>Rechnungsadresse hinzufügen</MaxBtn>}>
                {close => <BillingAddressEdit close={close} reload={loadBillingAddress} billingAddress={{
                    country: "AT",
                }}/>}
            </MyModal>
        </div>
        <Status type={"error"} text={error}/>
        <MyReactTable
            data={billingAddresses}
            loading={loading}
            pageSizeDef={400}
            columns={[
                {
                    Header: "Empfänger",
                    accessor: "recipient",
                    filterable: billingAddresses.length > 10,
                    Cell: nameCell || (({original, value}) => value),
                },
                {
                    Header: "Verein",
                    accessor: "club",
                    filterable: true,
                },
                {
                    Header: "E-Mail",
                    accessor: "email",
                    filterable: true,
                },
                {
                    Header: "Ort",
                    accessor: "city",
                    filterable: billingAddresses.length > 10,
                    Cell: ({original}) => <AddressPrinter {...original}/>
                },
                {
                    Header: "",
                    maxWidth: 250,
                    filterable: billingAddresses.length > 10,
                    Cell: ({original}) => <>
                        <MyModal trigger={<em>bearbeiten</em>}>
                            {close => <BillingAddressEdit close={close} reload={loadBillingAddress} billingAddress={original}/>}
                        </MyModal>
                        <em onClick={() => {
                            if (window.confirm("Rechnungsadresse überall löschen?")) {
                                maxiPost("/billing_address/hide", {ID: original.ID}, {setStatusVar}).then(loadBillingAddress)
                            }
                        }
                        }>löschen</em>
                    </>
                }
            ]}
        />
    </Container>
}

